module.exports = __webpack_public_path__ + "static/media/WIshList-Green.ee221a2a.png";